import { BloodIndentIssueDetails } from './BloodIndentIssueDetails';

import { Parameter } from './../../../../@core/interfaces/common/parameter';
import { Observable } from 'rxjs';

export interface BloodIndentIssueHeaaderParameter extends Parameter {
  searchTerm: number;
  orderBy: string;
}

export interface BloodIndentIssueHeaader {
  blIssueDate: any;
  blIssueDoneBy: string;
  blRegid: string;
  blIPID: any;
  blRequestBy: string;
  blSenderTenantId: string;
  blSenderBranchId: string;
  blReceiverTenantId:string;
  blReceiverBranchId:string;
  blSenderDepartmentId:string;
  blApproverTenantId: string;
  blApproverBranchId: string;
  blIssueStatus: string;
  blIssueflag:string;
  blIndentNo: string;
  blapprovalflag: string;
  blsendRequestflag: string;
  blInternalDepartmentId: number;
  createdBy:any;
  createdDate: string;
  updatedBy: any;
  updatedDate: string;
  tenantId: string;
  branchId: string;
  bloodIndentIssueDetDto: BloodIndentIssueDetails[];

}
export abstract class BloodIndentIssueHeaaderData {
  abstract list(url: string): Observable<any[]>;
  abstract getById(url: string): Observable<any>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
